
import { Controller } from "react-hook-form"
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const MpgAutocompleteSingle = ({ rhfFormInstance, label, name, type, sx, disabled, required, onChangeExtraHandler, optionList, startAdornmentComp, placeholder, defaultValue, disabledOptionIdArray }) => {
    // console.log("mydata:", optionList)
    const myStyle = {
        '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: '#f5f5f5',
        },
    }
    const { control } = rhfFormInstance

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue || ''}
            render={({
                field: { onChange, onBlur, value, name, ref, ...field },
                fieldState: { invalid, isTouched, isDirty, error },
                formState: { errors },
            }) => {
                // console.log("val-single", value)
                return (
                    <Autocomplete
                        disablePortal
                        fullWidth
                        disabled={!!disabled}
                        id={`${name}-mpg-autocomplete-multi`}
                        value={value} //IMP
                        options={optionList}
                        defaultValue={defaultValue || ''}

                        /**to disable options */
                        getOptionDisabled={(option) => {
                            /**by this, we can add "selectOptionDisabled" true during creating autocomplete list*/
                            if (!!option?.selectOptionDisabled) {
                                return true
                            }

                            /**by this we can pass array of unique ids to be diabaled */
                            if (!!disabledOptionIdArray) {
                                return !!disabledOptionIdArray.includes(option.id)
                            }
                        }}

                        getOptionLabel={(option) => {
                            return option.selectOptionLabel || ""
                        }}

                        onChange={(e, values, reason, details) => {
                            onChange(values)

                            if (!!onChangeExtraHandler) {
                                /**passing all args from onchange event*/
                                onChangeExtraHandler(e, values, reason, details)
                            }
                        }}
                        isOptionEqualToValue={(option, value) => option.selectOptionValue === value.selectOptionValue}

                        sx={[myStyle, sx]}

                        renderOption={
                            (props, optionList) => (
                                <Box sx={{ width: '100%', textAlign: 'left' }} component='li' {...props} key={optionList.id}>
                                    {optionList.selectOptionLabel}
                                </Box>
                            )
                        }


                        ListboxProps={{ style: { maxHeight: '200px' } }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                {...field}
                                inputRef={ref}
                                margin='normal'
                                label={label}
                                placeholder={placeholder}
                                size='large'
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required={!!required}
                                error={!!error}
                                helperText={error && error.message}
                            />
                        )}
                    />
                )
            }}
        />

    )
}
export default MpgAutocompleteSingle